import { useTranslation } from "react-i18next";
import StarElementsTile from "./StarElementsTile";
import * as _ from "lodash";
import { formatNumber } from "../../helpers/templateHelpers";

function StarElementsTileContainer(props) {
  const { t } = useTranslation();

  const getQuestionStats = (stats, compStats) => {
    if (compStats.length < 1) {
      return _.map(stats, (s) => _.extend({ diff: 0 }, s));
    }

    let finalStats = _.map(stats, (s) => _.extend({ diff: "" }, s));
    if (stats.score) {
      for (let i in finalStats) {
        finalStats[i].diff = formatNumber(
          stats[i].score - compStats[i].score,
          1
        );
      }
    }
    return finalStats;
  };

  const generateQueryStats = (detailedRatings, compDetailedRatings) => {
    if (!detailedRatings) return undefined;
    let stats = [];

    if (!_.isEqual(detailedRatings, compDetailedRatings)) {
      stats = _.differenceWith(detailedRatings, compDetailedRatings, _.isEqual);
    } else {
      stats = detailedRatings;
    }
    let compStats = _.intersectionBy(compDetailedRatings, stats, "name");
    return getQuestionStats(stats, compStats);
  };

  const generateModuleStats = (highestRatings, compHighestRatings) => {
    if (!highestRatings) return undefined;
    let moduleStats = [];
    if (!_.isEqual(highestRatings, compHighestRatings)) {
      moduleStats = _.differenceWith(
        highestRatings,
        compHighestRatings,
        _.isEqual
      );
    } else {
      moduleStats = _.cloneDeep(highestRatings);
    }

    let compModuleStats = _.intersectionBy(
      compHighestRatings,
      moduleStats,
      "name"
    );

    return getQuestionStats(moduleStats, compModuleStats);
  };

  let queryStats = generateQueryStats(
    props.detailedRatings,
    props.compDetailedRatings
  );

  let moduleStats = generateModuleStats(
    props.highestRatings,
    props.compHighestRatings
  );

  return (
    <div>
      <div>
        {queryStats && (
          <StarElementsTile
            title={t("admin.report.ch1")}
            emptyText={t("admin.report.ce1")}
            stats={queryStats}
          />
        )}
      </div>
      <div>
        {moduleStats && (
          <StarElementsTile
            title={t("admin.report.ch2")}
            emptyText={t("admin.common.noRevCond")}
            stats={moduleStats}
          />
        )}
      </div>
    </div>
  );
}

export default StarElementsTileContainer;
